import React, { useCallback, useEffect, useRef, useState } from 'react';
import ComboMultiple from '../../../../../shared/components/Combos/Multiple';
import { createOptions } from './functions';
import Flag from 'react-flagkit';
import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';

export const ComboSociedades = (props:any) =>{

  let {options, selectedOptions,onChange, optionAll, firstDefault} = props;
  let [comboOptions, setComboOptions] = useState(options)
  const hasInitialized = useRef(false); //controla que se ejecute sólo una vez

  useEffect(()=>{
    if(options){
      console.log('comboSociedades options')
      setComboOptions(createOptions(options,optionAll))
    }
  },[options,optionAll])

  useEffect(() => {
    if (
      comboOptions &&
      comboOptions.length > 0 &&
      !hasInitialized.current
    ) {
      console.log('comboSociedades onChange auto');
      hasInitialized.current = true;

      let newSelection;

      if (firstDefault === true) {
        newSelection = [comboOptions[0]];
      } else if (selectedOptions) {
        newSelection = Array.isArray(selectedOptions)
          ? selectedOptions
          : comboOptions.filter((o: any) => o.value === selectedOptions);
      }

      // Llamar onChange sólo si hay una selección válida
      if (newSelection && newSelection.length > 0) {
        onChange && onChange(newSelection);
      }
    }
  }, [comboOptions, selectedOptions, firstDefault]);

  // useEffect(()=>{
  //   if(comboOptions && comboOptions.length>0)
  //   {
  //     console.log('comboSociedades onChange auto')
  //     if(firstDefault===true){
  //       onChange && onChange([comboOptions[0]])
  //     }else{
  //     let select = !Array.isArray(selectedOptions) ? comboOptions.filter((o:any) => o.value===selectedOptions) : selectedOptions
  //     onChange && onChange(select)
  //     }
  //   }
  // },[comboOptions,selectedOptions])

  const onCreateOption = (searchValue:any, flattenedOptions = []) => {
    if (!searchValue) {
      return;
    }

    const normalizedSearchValue = searchValue.trim().toLowerCase();

    if (!normalizedSearchValue) {
      return;
    }

    const newOption = {
      value: searchValue,
      label: searchValue,
    };

    // Create the option if it doesn't exist.
    if (
      flattenedOptions.findIndex(
        (option:any) => option.label.trim().toLowerCase() === normalizedSearchValue
      ) === -1
    ) {
      const newOptions = [...options, newOption];
      setComboOptions(newOptions);
    }

    // Select the option.
    onChange && onChange([...selectedOptions, newOption])
  };

  const renderOption = (option:any, searchValue:any, contentClassName:any) => {
    const { label, value } = option;
    return (
      <EuiFlexGroup>
      <EuiFlexItem grow={false}>
        {option.codPais ? <Flag country={option.codPais} /> : null}
      </EuiFlexItem>
      <EuiFlexItem>
        <span>{label}</span>
      </EuiFlexItem>
      </EuiFlexGroup>
    );
  };
 
  return (
    <ComboMultiple {...{...props,...{options:(comboOptions),renderOption:renderOption,onCreateOption:onCreateOption}}} id="comboSociedades"/>
  )
}
export default ComboSociedades